import * as types from "./types";

export const setOrganization = ({
  id,
  name,
  slug,
  logo,
  powered_by_logo,
  powered_by_url,
  background,
  colors,
  track_taker_session,
  use_2FA,
  language_configuration,
}) => {
  return {
    type: types.SET_ORGANIZATION,
    payload: {
      id,
      name,
      slug,
      logo,
      powered_by_logo,
      powered_by_url,
      background,
      colors,
      track_taker_session,
      use_2FA,
      language_configuration,
    },
  };
};

export const setOrganizationSlug = slug => {
  return {
    type: types.SET_ORGANIZATION_SLUG,
    payload: slug,
  };
};

export const setOrganizationResponsibleUsers = responsibleUsers => {
  return {
    type: types.SET_RESPONSIBLE_USERS,
    payload: responsibleUsers,
  };
};

export const setFeedbackAssignee = assignee_id => {
  return {
    type: types.SET_FEEDBACK_ASSIGNEE,
    payload: assignee_id,
  };
};

export const setLogo = logo => {
  return {
    type: types.SET_LOGO_IMAGE,
    payload: logo,
  };
};

export const setPoweredByLogo = logo => {
  return {
    type: types.SET_POWERED_BY_LOGO_IMAGE,
    payload: logo,
  };
};

export const setBackground = background => {
  return {
    type: types.SET_BACKGROUND_IMAGE,
    payload: background,
  };
};

export const addDivisions = divisions => {
  return {
    type: types.ADD_DIVISIONS,
    payload: divisions,
  };
};
